// extracted by mini-css-extract-plugin
export default {"popupBody":"MessageAlert_popupBody__mENAj","closeBtn":"MessageAlert_closeBtn__ok6IC","networkAlert":"MessageAlert_networkAlert__MZ40W","errorImage":"MessageAlert_errorImage__DwVGF"};